<template>
    <div>
      <Pos_history_import_detail/>
    </div>
  </template>
  
  <script>
  import Pos_history_import_detail from "@/components/adminArin/pos_system/warehouse/inventory/Pos_history_import_detail";
  export default {
    name: "PosHistoryImportDetail",
    components: {
        Pos_history_import_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  